<template lang="pug">
  .section-container
    .section-header
      .row
        .col
          h5 {{ message }}
        .col.text-right(v-if="required")
          span.red *
          |  Indicates Required Field
    .section.mt-3
      slot
</template>

<script>
export default {
  name: 'AccountSection',
  props: {
    message: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.section-header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e6e6e6;
}

.section {
  background-color: #f8f8f8;
  padding: 1rem;
}

.red {
  color: #a62226;
}
</style>
